var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 511,
    viewBox: "0 0 352 511",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 351,
    height: 510,
    rx: 3.5,
    stroke: "#475569"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.41221,
    y1: 4.71701,
    x2: 349.412,
    y2: 508.717,
    stroke: "#475569"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.58779,
    y1: 508.717,
    x2: 348.589,
    y2: 4.71753,
    stroke: "#475569"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLarge);
export default __webpack_public_path__ + "static/media/media_large.28837991dc336d596f12d7dc12d8098d.svg";
export { ForwardRef as ReactComponent };